import React from 'react';
import PropTypes from 'prop-types';
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';

import './AuthorAvatar.scss';

const transform = {
    avatar: 'ar_1:1,c_fill/c_scale,w_34,dpr_auto,q_auto,f_auto,fl_lossy',
};

export default class AuthorAvatar extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        imageId: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        displayText: PropTypes.string.isRequired,
    };

    static defaultProps = {};

    render() {
        const { imageId, alt, displayText } = this.props;
        const src = buildImagePath(imageId, 'avatar', transform);
        return (
            <div className="component-Employer-Marketing-AuthorAvatar">
                <img src={src} className="avatar-image" alt={alt} />
                <span className="byline-text">{displayText}</span>
            </div>
        );
    }
}
